import { NgModule } from '@angular/core';

import { MingaEffects } from './minga.effects';

@NgModule({
  providers: [MingaEffects],
  imports: [],
  declarations: [],
})
export class MingaEffectsModule {}
